import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-call",
  "use": "icon-call-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-call\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#2FCA74\" d=\"M19.846 17.812c-.457 1.26-1.588 2.102-2.832 2.188C9.23 20 4 14.797 4 6.953v-.055c.1-1.231.94-2.29 2.183-2.744 1.689-.616 2.333.703 2.947 2.396.615 1.693.967 3.118-.721 3.734-.194.07-.39.116-.588.148.69 2.844 2.925 5.062 5.763 5.743.032-.2.078-.398.148-.594.614-1.693 2.036-1.34 3.725-.723 1.688.616 3.004 1.26 2.39 2.954z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol